<template>
<div>
<v-row
    v-if="show_time"
>
    <v-col style="padding-top: 2px; padding-bottom: 2px;" class="text-center">
        <div class="hint">
                {{ time }}
            </div>
    </v-col>
</v-row>
<v-row
    v-if="message.isSystemMessage()"
>
    <v-col style="padding-top: 2px; padding-bottom: 2px;" class="text-center">
        <div class="alert">
            {{message.getContentAsObject().text}}
        </div>
    </v-col>
</v-row>
<v-row
    v-if="!prev_message_same_author && is_right && !message.isSystemMessage()"
>
    <v-col v-bind:style="{'padding-right': '85px'}" class="text-right author_label">
        {{message.getLabelAuthor()}}
    </v-col>
</v-row>
<v-row
    v-if="!prev_message_same_author && is_left && !message.isSystemMessage()"
>
    <v-col v-bind:style="{'padding-left': '85px'}" class="text-left author_label">
        {{message.getLabelAuthor()}} 
    </v-col>
</v-row>
<v-row
    v-if="!message.isSystemMessage()"
    style="padding-top: 0px; padding-bottom: 0px; "
>
        <v-col class="left_letter_gutter text-center" align-self="end"> 
            <m-avatar
                v-if="is_left && !next_message_same_author"
                :avatar="message.getAuthorAvatar()"
                />
        </v-col>

        <v-col style="padding-top: 2px; padding-bottom: 2px;">
             
            <v-hover
                v-slot:default="{ hover }"
                v-if="is_left"
            >
                    <div style="display: flex; align-items: center;">
                        <m-message-content 
                            :message="message"
                            :is_left="is_left"
                        />
                        
                        <div style="flex-grow: 0;">
                            <m-message-context-menu 
                                :message="message" 
                                :hover="hover"
                                :is_left="true"
                                v-on:message-details="$emit('message-details',$event)"
                                v-on:create-saved-message="$emit('create-saved-message',$event)"
                                v-on:admin-edit-message="$emit('admin-edit-message',$event)"
                                v-on:import-vcard="$emit('import-vcard', $event)"
                                v-on:edit-scheduled-message="$emit('edit-scheduled-message', $event)"
                                v-on:edit-note="$emit('edit-note',$event)"
                            />
                        </div>
                    </div>
            </v-hover>

            <v-hover
                v-slot:default="{ hover }"
                v-if="is_right"
            >
                <div v-if="is_right">
                    <div style="display: flex; align-items: center; justify-content: flex-end">
                        <div style="flex-grow: 0;">
                            <m-message-context-menu 
                                :message="message" 
                                :hover="hover"
                                :is_left="false"
                                v-on:message-details="onShowMessageDetails($event);"
                                v-on:admin-edit-message="$emit('admin-edit-message',$event)"
                                v-on:create-saved-message="$emit('create-saved-message',$event)"
                                v-on:bulk-message-set-outcome="$emit('bulk-message-set-outcome',$event)"
                                v-on:import-vcard="$emit('import-vcard', $event)"
                                v-on:edit-note="$emit('edit-note',$event)"
                                v-on:edit-scheduled-message="$emit('edit-scheduled-message', $event)"
                            />
                            
                        </div>
                        
                        <m-message-content 
                            :message="message"
                            :is_left="is_left"
                        />
                        
                    </div>
                </div>
            </v-hover>
            
        </v-col>

        <v-col class="right_letter_gutter text-center" align-self="end"> 
            <m-avatar
                v-if="is_right && !next_message_same_author"
                :avatar="message.getAuthorAvatar()"
                />
        </v-col>
</v-row>
</div>
</template>

<script>
const Time = require('@/js/time.js');


export default {

    props: {
        message: {
            type: Object
        },
        next_message: {
            type: Object,
            default: function () { return null; },
        },
        previous_message: {
            type: Object,
            default: function () { return null; },
        },
        for_endpoint: {
            type: String,
        }
    },

    data() {
        return {
        }
    },

    methods: {
        onShowMessageDetails(stored_message_id)
        {
            this.$emit('message-details',stored_message_id);
        },
    },

    computed: {
        is_left() {
            return this.message.getAuthor() !== this.for_endpoint;
        },

        is_right()
        {
            return this.message.getAuthor() === this.for_endpoint;
        },

        prev_message_same_author() 
        {
            if ( this.previous_message === null ) 
                return false;

            return this.message.getLabelAuthor() === this.previous_message.getLabelAuthor();
        },

        next_message_same_author() 
        {
            if ( this.next_message === null ) 
                return false;

            return this.message.getLabelAuthor() === this.next_message.getLabelAuthor();
        },

        show_time()
        {
            if ( this.previous_message === null ) 
                return true;

            return this.message.getTime() - this.previous_message.getTime() > 5*60*1000; // 5 minutes
        },

        avatar_color()
        {
            return this.message.getAuthorAvatar().getColor();
        },

        time()
        {
            return Time.getHumanReadableTimelineTime(this.message.getTime());
        },
    },
}
</script>

<style lang="scss" scoped>

.right_letter_gutter
{
    max-width: 60px;
    min-width: 60px;
    padding-top: 2px; 
    padding-bottom: 5px;
    padding-left: 0px;
}

.left_letter_gutter,
{
    max-width: 60px;
    min-width: 60px;
    padding-top: 2px; 
    padding-bottom: 2px;
    padding-left: 20px;
}

.message_container
{
    display: flex;

    padding-bottom: 5px;
}

.center_container
{
    padding-left: 5px;
    
}

.alert
{
    font-family: Roboto;
    font-size: 12px;

    margin: 15px;
}

.hint
{
    display: inline-block;
    color: rgba(0,0,0,0.5);
    font-family: Roboto;
    font-size: 12px;
}

.author_label
{
    font-family: Roboto;
    font-size: 12px;
}

</style>